import { render, staticRenderFns } from "./RenShi1.vue?vue&type=template&id=b6c6499c&scoped=true&"
import script from "./RenShi1.vue?vue&type=script&lang=js&"
export * from "./RenShi1.vue?vue&type=script&lang=js&"
import style0 from "./RenShi1.vue?vue&type=style&index=0&id=b6c6499c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c6499c",
  null
  
)

export default component.exports